<ppl-input-container>
  <input
    #searchInput
    [disabled]="disabled"
    pplInput
    type="text"
    [value]="value"
    (input)="onChange($event)"
    autocomplete="off"
    [placeholder]="placeholder"
    (keyup.escape)="onKeyEscapePressed()"
    (keydown.arrowUp)="$event.preventDefault()"
    (keydown.arrowDown)="$event.preventDefault()"
    (focus)="valueFocus.emit()"
    (blur)="valueBlur.emit()" />

  @if (ngUiTheme === 'pipeliner') {
    @if (!disabled && inputValue.length === 0 && !alwaysDisplayRemoveButton) {
      <ppl-icon
        svgIcon="search"
        width="14px"
        height="14px"></ppl-icon>
    }
    @if ((!disabled && inputValue.length !== 0) || alwaysDisplayRemoveButton) {
      <ppl-icon
        class="clear-icon"
        svgIcon="closering-red2"
        width="14px"
        height="14px"
        (click)="clearValue()"></ppl-icon>
    }
  }
  @if (ngUiTheme === 'fabric') {
    <ppl-icon
      svgIcon="search-sm"
      width="16px"
      height="16px"></ppl-icon>
    @if ((!disabled && inputValue.length !== 0) || alwaysDisplayRemoveButton) {
      <ppl-icon
        class="clear-icon"
        svgIcon="close-gray-sm"
        width="12px"
        height="12px"
        (click)="clearValue()"></ppl-icon>
    }
  }
  @if (ngUiTheme === 'material') {
    <div
      class="clear-icon-container"
      (click)="clearValue()">
      @if ((!disabled && inputValue.length !== 0) || alwaysDisplayRemoveButton) {
        <ppl-icon
          class="clear-icon"
          svgIcon="close-24px"
          width="12px"
          height="12px"></ppl-icon>
      }
    </div>
  }
</ppl-input-container>
